// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"hero-slider_scroll-black__WPXK7","featured-slider":"hero-slider_featured-slider__2UQQS","slide":"hero-slider_slide__Q80Eb"};